import React from "react";

function SubTitle({ children }) {
  return <h2 className="tcf-subtitle">{children}</h2>;
}

export default SubTitle;
